import { getLocalAuth } from "./AuthUtils";

function isActivePrivilegeRead(page) {
    const values = getLocalAuth()
    const privilege = JSON.parse(values.authPrivilege);

    let dataPrivilege = privilege.data.menu.filter(data => {
        return data.code === page
    });

    let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
        return data.code === "Read"
    });

    return dataRead.length === 0 ? false : dataRead[0].is_active;
}

export { isActivePrivilegeRead }